
interface LogzioLoggerConfig {
  token: string
  url?: string
}

const DEFAULT_LOGZIO_URL = 'https://listener.logz.io:8091'

export default class LogzioLogger {

  #token: string
  #url: string

  constructor({token, url}: LogzioLoggerConfig) {

    this.#token = token
    this.#url = url || DEFAULT_LOGZIO_URL
  }

  log(data: string | object) {

    try {

      const logObj = typeof data === 'object' ? data : {message: data}
      const urlToReport = new URL(this.#url)
      const reportingParams = urlToReport.searchParams

      reportingParams.append('token', this.#token)

      Object.keys(logObj).forEach((key: keyof typeof logObj) => {
        reportingParams.append(key, logObj[key])
      })

      const img = new Image()
      img.src = urlToReport.toString()
    }
    catch (e) {
      // tslint:disable-next-line:no-console
      console.log(`Failed to send log because of exception:\n${  e}`)
    }
  }
}
